<template>
  <SbBlockUi>
    <div class="sb-upload-dialog">
      <div class="sb-upload-dialog__content">
        <SbIcon
          class="sb-upload-dialog__refreshing"
          name="refreshing"
          color="primary"
        />
        <span class="sb-upload-dialog__label"> {{ labelToUpload }} </span>
      </div>
      <SbProgressBar :model-value="percentageValue" show-percentage />
    </div>
  </SbBlockUi>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SbIcon from '../Icon'
import { SbProgressBar } from '../ProgressBar'
import SbBlockUi from '../BlockUI'
import i18n, { type Locale } from '../../i18n'

defineOptions({
  name: 'SbUploadDialog',
})

export type UploadDialogProps = {
  // current file index (1-based)
  currentFile?: number
  // name of the current file being uploaded
  currentFileName?: string
  // upload progress percentage (0-100)
  percentageValue?: number
  // total number of files being uploaded
  totalFiles?: number
  // locale for translations, default is 'en'
  locale?: Locale
}

const props = withDefaults(defineProps<UploadDialogProps>(), {
  currentFile: 0,
  percentageValue: 0,
  totalFiles: 0,
  locale: 'en',
})

const labelToUpload = computed(() => {
  if (props.currentFileName) {
    return `${uploadingLabel.value} - ${props.currentFileName}`
  }
  return uploadingLabel
})

const uploadingLabel = computed(() => {
  const ofTranslated = i18n(props.locale, 'of')
  const fileTranslated = i18n(props.locale, 'file')
  const filesTranslated = i18n(props.locale, 'files')
  const uploadingTranslated = i18n(props.locale, 'uploading')

  if (props.totalFiles === 1) {
    return `${uploadingTranslated} ${props.currentFile} ${ofTranslated} ${props.totalFiles} ${fileTranslated}`
  }
  return `${uploadingTranslated} ${props.currentFile} ${ofTranslated} ${props.totalFiles} ${filesTranslated}`
})
</script>
